import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async getAllByBrand() {
        return await http.get(buildUrlFromLocation("/brand-has-zone-groups/list"));
    }
};



// WEBPACK FOOTER //
// ./src/services/brandHasZoneGroup.js